import { render } from "./target_vs_achievement_details.vue?vue&type=template&id=8a4df6b0"
import script from "./target_vs_achievement_details.vue?vue&type=script&lang=js"
export * from "./target_vs_achievement_details.vue?vue&type=script&lang=js"

import "./target_vs_achievement_details.vue?vue&type=style&index=0&id=8a4df6b0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__